import { useDefaultShakhsSherkat } from "context/ShakhsContext";
import { useEffect, useState } from "react";


const Clock = () => {
  const { serverOffset } = useDefaultShakhsSherkat();
  const [time, setTime] = useState(null);

  useEffect(() => {
    if (serverOffset === null) return; 

    setTime(new Date(Date.now() + serverOffset));

    const timer = setInterval(() => {
      setTime(new Date(Date.now() + serverOffset));
    }, 1000);

    return () => clearInterval(timer);
  }, [serverOffset]);

  if (!time) return null;

  return <span>{time.toLocaleTimeString("fa-IR")}</span>;
};

export default Clock;